import { useRef, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useAppDispatch } from '../../../../store';
import {
  fromPaymentMethod,
} from '../../../../store/rootReducer';
import PaymentForm from './PaymentForm';
import { useReadOnlyMode } from '../../../../routes';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!);

const StripePaymentElement = (
  { options }: {
    options?: StripeElementsOptions;
  },
) => {
  const dispatch = useAppDispatch();
  const paymentFormRef = useRef<any>(null);
  const [isShowSaveBtn, setIsShowSaveBtn] = useState(false);

  const isReadOnly = useReadOnlyMode();

  const refetchPaymentMethod = () => {
    dispatch(fromPaymentMethod.doResetState());
  };

  const handleSubmit = () => {
    paymentFormRef.current.handleSubmit();
  };

  const showSaveBtn = (show: boolean) => {
    setIsShowSaveBtn(show);
  };

  return (
    <Box
      key="card-information"
      id="card-information"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      pt={2}
    >
      <Box
        id="stripe-payment-element-title"
        key="stripe-payment-element-title"
        display="flex"
        justifyContent="space-between"
      >
        <Typography variant="h3" pb={1} mb={1.5} fontWeight={700}>
          <FormattedMessage id="billinginfo.payment" />
        </Typography>
        <Box
          id="stripe-payment-element-action-btns"
          key="stripe-payment-element-action-btns"
          display="flex"
        >
          {isShowSaveBtn && (
            <Button
              id="card-submit-btn"
              variant="outlined"
              onClick={handleSubmit}
              disabled={isReadOnly}
              sx={{
                fontWeight: 500,
                height: 40,
                width: 72,
                float: 'right',
                color: '#fff',
                backgroundColor: '#5959EB',
                '&:hover': {
                  backgroundColor: '#43509B',
                },
              }}
            >
              <FormattedMessage id="billinginfo.button.save" />
            </Button>
          )}
        </Box>
      </Box>
      <Elements stripe={stripePromise} options={options}>
        <PaymentForm
          ref={paymentFormRef}
          mode="setup"
          refetchPaymentMethod={refetchPaymentMethod}
          showSaveBtn={showSaveBtn}
        />
      </Elements>
    </Box>
  );
};

export default StripePaymentElement;
